<script>
import { Bar } from 'vue-chartjs'

export default {
  name: 'ControlChart',

  extends: Bar,
  props: {
    propsValues: {
      type: Array,
      default: null,
    },
    propsXRange: {
      type: Array,
      default: null,
    },
    propsYRange: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      data: {},
      initialMin: 0,
      initialMax: 0,
      options: {
        responsive: true,
        maintainAspectRatio: false,
        title: {
          display: true,
          fontSize: '24',
          text: this.$t('ELE0272'),
        },
        layout: {
          padding: {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
          },
        },
        scales: {
          xAxes: [
            {
              display: true,
              ticks: {
                autoSkip: true,
                autoSkipPadding: 0,
                maxRotation: 45,
                minRotation: 45,
                callback: function (value) {
                  return this.chart.data.ticks[this.chart.data.labels.indexOf(value)]
                },
              },
              gridLines: {
                drawOnChartArea: false,
                tickMarkLength: 5,
              },
            },
          ],
          yAxes: [
            {
              display: true,
              ticks: {
                min: 0,
                max: 0,
              },
              scaleLabel: {
                display: true,
                labelString: this.$t('ELE0202'),
              },
              gridLines: {
                display: false,
              },
            },
          ],
        },
        legend: {
          display: true,
          position: 'bottom',
          labels: {
            generateLabels: function (chart) {
              return chart.data.datasets.map(function (dataset, i) {
                return {
                  text: dataset.label,
                  fillStyle: '#FFFFFF',
                  lineDash: dataset.borderDash,
                  strokeStyle: dataset.borderColor,
                  hidden: !chart.isDatasetVisible(i),
                  datasetIndex: i,
                }
              })
            },
          },
        },
        tooltips: {
          backgroundColor: 'rgba(0,0,0,0.7)',
          displayColors: true,
          enabled: true,
          mode: 'index',
          intersect: false,
          callbacks: {
            title: function (tooltipItems, data) {
              return data.ticks[tooltipItems[0].index]
            },
            label: function (tooltipItem, data) {
              let result = []
              if (tooltipItem.datasetIndex === 1) {
                result.push(data.tooltips1[tooltipItem.index])
                if (data.tooltips2[tooltipItem.index] != '') {
                  result.push(data.tooltips2[tooltipItem.index])
                }
              }
              return result
            },
          },
        },
        plugins: {
          datalabels: {
            display: false,
          },
        },
      },
    }
  },
  computed: {
    values: function () {
      return this.propsValues
    },
    yRange: function () {
      return this.propsYRange
    },
    xRange: function () {
      return this.propsXRange
    },
  },
  methods: {
    setValues() {
      let data = {
        labels: [],
        datasets: [],
        ticks: [],
        tooltips1: [],
        tooltips2: [],
      }

      let value = []
      let style = []
      let radius = []
      let hoverRadius = []
      let color = []
      let bgColor = []
      let std = []
      let upper = []
      let lower = []
      let clUpper = []
      let clLower = []
      let saStd = []
      let saUpper = []
      let saLower = []
      let cl = []
      let ucl = []
      let lcl = []

      for (let i = this.xRange[0]; i <= this.xRange[1]; i++) {
        if (this.values.length > i) {
          value.push(this.values[i].value)
          style.push(this.values[i].isResultOk === true ? 'circle' : 'crossRot')
          radius.push(this.values[i].isResultOk === true ? 3 : 9)
          hoverRadius.push(this.values[i].isResultOk === true ? 6 : 12)
          color.push(this.values[i].isResultOk === true ? '#10218B' : '#F44336')
          bgColor.push(this.values[i].isResultOk === true ? '' : '#F44336')
          std.push(this.values[i].limit.std !== null ? this.values[i].limit.std : 0)
          upper.push(
            (this.values[i].limit.upper !== null ? this.values[i].limit.upper : null) +
              (this.values[i].limit.std ? this.values[i].limit.std : null),
          )
          lower.push(
            (this.values[i].limit.lower !== null ? this.values[i].limit.lower : null) +
              (this.values[i].limit.std ? this.values[i].limit.std : null),
          )
          clUpper.push(
            (this.values[i].clLimit.upper !== null ? this.values[i].clLimit.upper : null) +
              (this.values[i].clLimit.std ? this.values[i].clLimit.std : null),
          )
          clLower.push(
            (this.values[i].clLimit.lower !== null ? this.values[i].clLimit.lower : null) +
              (this.values[i].clLimit.std ? this.values[i].clLimit.std : null),
          )
          if (this.values[i].saLimit) {
            saStd.push(this.values[i].saLimit.std !== null ? this.values[i].saLimit.std : 0)
            saUpper.push(
              (this.values[i].saLimit.upper !== null ? this.values[i].saLimit.upper : null) +
                (this.values[i].saLimit.std ? this.values[i].saLimit.std : null),
            )
            saLower.push(
              (this.values[i].saLimit.lower !== null ? this.values[i].saLimit.lower : null) +
                (this.values[i].saLimit.std ? this.values[i].saLimit.std : null),
            )
          } else {
            saStd.push(null)
            saUpper.push(null)
            saLower.push(null)
          }
          if (this.values[i].controlLimit) {
            cl.push(this.values[i].controlLimit.cl)
            ucl.push(this.values[i].controlLimit.ucl)
            lcl.push(this.values[i].controlLimit.lcl)
          }
          data.labels.push(i)
          data.ticks.push(this.values[i].tick)
          data.tooltips1.push(
            this.getToolTips1(
              this.values[i].value,
              this.values[i].limit.std,
              this.values[i].limit.upper,
              this.values[i].limit.lower,
            ),
          )
          if (Object.keys(this.values[i].saLimit).length) {
            data.tooltips2.push(
              this.getToolTips2(this.values[i].saLimit.std, this.values[i].saLimit.upper, this.values[i].saLimit.lower),
            )
          } else {
            data.tooltips2.push('')
          }
        } else {
          value.push(null)
          style.push('')
          radius.push('')
          hoverRadius.push('')
          color.push('')
          bgColor.push('')
          std.push(null)
          upper.push(null)
          lower.push(null)
          clUpper.push(null)
          clLower.push(null)
          saStd.push(null)
          saUpper.push(null)
          saLower.push(null)
          data.labels.push(null)
          data.ticks.push(null)
        }
      }

      data.datasets.push({
        label: this.$t('ELE0202'),
        data: value,
        borderColor: '#10218B',
        borderWidth: 2,
        fill: false,
        type: 'line',
        lineTension: 0,
        pointRadius: radius,
        pointBorderColor: color,
        pointBorderWidth: 3,
        pointBackgroundColor: color,
        pointHoverRadius: hoverRadius,
        pointHoverBorderColor: color,
        pointHoverBorderWidth: 3,
        pointHoverBackgroundColor: bgColor,
        pointStyle: style,
        backgroundColor: color,
        spanGaps: true,
        hidden: false,
      })

      data.datasets.push({
        label: this.$t('ELE0095'),
        data: std,
        borderColor: '#000000',
        pointBorderColor: '#FB8C00',
        pointBackgroundColor: '#FB8C00',
        borderWidth: 1.5,
        fill: false,
        type: 'line',
        lineTension: 0,
        pointRadius: 1,
        pointHoverRadius: 1,
        backgroundColor: '#FB8C00',
        spanGaps: true,
        hidden: false,
      })

      data.datasets.push({
        label: this.$t('ELE0096'),
        data: upper,
        borderColor: '#F44336',
        pointBorderColor: '#F44336',
        pointBackgroundColor: '#FB8C00',
        borderWidth: 1.5,
        fill: false,
        type: 'line',
        lineTension: 0,
        pointRadius: 1,
        pointHoverRadius: 1,
        backgroundColor: '#FB8C00',
        spanGaps: true,
        hidden: false,
      })

      data.datasets.push({
        label: this.$t('ELE0097'),
        data: lower,
        borderColor: '#F44336',
        pointBorderColor: '#F44336',
        pointBackgroundColor: '#FB8C00',
        borderWidth: 1.5,
        fill: false,
        type: 'line',
        lineTension: 0,
        pointRadius: 0.5,
        pointHoverRadius: 0.5,
        backgroundColor: '#FB8C00',
        spanGaps: true,
        hidden: false,
      })
      data.datasets.push({
        label: this.$t('ELE0538'),
        data: clUpper,
        borderColor: '#F44336',
        pointBorderColor: '#F44336',
        pointBackgroundColor: '#FB8C00',
        borderWidth: 1.5,
        fill: false,
        type: 'line',
        lineTension: 0,
        pointRadius: 0.5,
        pointHoverRadius: 0.5,
        backgroundColor: '#FB8C00',
        spanGaps: false,
        borderDash: [10, 3],
        hidden: false,
      })
      data.datasets.push({
        label: this.$t('ELE0539'),
        data: clLower,
        borderColor: '#ff0000',
        pointBorderColor: '#ff0000',
        pointBackgroundColor: '#ff0000',
        borderWidth: 1.5,
        fill: false,
        type: 'line',
        lineTension: 0,
        pointRadius: 0.5,
        pointHoverRadius: 0.5,
        backgroundColor: '#FB8C00',
        spanGaps: false,
        borderDash: [10, 3],
        hidden: false,
      })

      data.datasets.push({
        label: this.$t('ELE0273'),
        data: saStd,
        borderColor: '#3CA5BA',
        pointBorderColor: '#3CA5BA',
        pointBackgroundColor: '#3CA5BA',
        borderWidth: 1.5,
        fill: false,
        type: 'line',
        lineTension: 0,
        pointRadius: 2.5,
        pointHoverRadius: 2.5,
        backgroundColor: '#3CA5BA',
        spanGaps: false,
        hidden: false,
      })

      data.datasets.push({
        label: this.$t('ELE0274'),
        data: saUpper,
        borderColor: '#43A047',
        pointBorderColor: '#43A047',
        pointBackgroundColor: '#43A047',
        borderWidth: 1.5,
        fill: false,
        type: 'line',
        lineTension: 0,
        pointRadius: 2.5,
        pointHoverRadius: 2.5,
        backgroundColor: '#43A047',
        spanGaps: false,
        hidden: false,
      })

      data.datasets.push({
        label: this.$t('ELE0275'),
        data: saLower,
        borderColor: '#43A047',
        pointBorderColor: '#43A047',
        pointBackgroundColor: '#43A047',
        borderWidth: 1.5,
        fill: false,
        type: 'line',
        lineTension: 0,
        pointRadius: 2.5,
        pointHoverRadius: 2.5,
        backgroundColor: '#43A047',
        spanGaps: false,
        hidden: false,
      })

      data.datasets.push({
        label: this.$t('ELE0499'),
        data: cl,
        borderColor: '#FB8C00',
        pointBorderColor: '#FB8C00',
        pointBackgroundColor: '#FB8C00',
        borderWidth: 1.5,
        fill: false,
        type: 'line',
        lineTension: 0,
        pointRadius: 0.5,
        pointHoverRadius: 0.5,
        backgroundColor: '#FB8C00',
        spanGaps: false,
        borderDash: [10, 3],
        hidden: false,
      })

      data.datasets.push({
        label: this.$t('ELE0506'),
        data: ucl,
        borderColor: '#8E24AA',
        pointBorderColor: '#8E24AA',
        pointBackgroundColor: '#8E24AA',
        borderWidth: 1.5,
        fill: false,
        type: 'line',
        lineTension: 0,
        pointRadius: 0.5,
        pointHoverRadius: 0.5,
        backgroundColor: '#8E24AA',
        spanGaps: false,
        borderDash: [10, 3],
        hidden: false,
      })

      data.datasets.push({
        label: this.$t('ELE0507'),
        data: lcl,
        borderColor: '#8E24AA',
        pointBorderColor: '#8E24AA',
        pointBackgroundColor: '#8E24AA',
        borderWidth: 1.5,
        fill: false,
        type: 'line',
        lineTension: 0,
        pointRadius: 0.5,
        pointHoverRadius: 0.5,
        backgroundColor: '#8E24AA',
        spanGaps: false,
        borderDash: [10, 3],
        hidden: false,
      })

      this.data = data
    },
    displayChart() {
      this.setValues()
      this.options.scales.yAxes[0].ticks.min = this.yRange[0]
      this.options.scales.yAxes[0].ticks.max = this.yRange[1]
      this.$refs.canvas.height = 340
      this.renderChart(this.data, this.options)
    },
    getToolTips1(val, std, upper, lower) {
      let result = `${this.$t('ELE0202')}: ${val}`
      if (std !== null) {
        result = result + `, ${this.$t('ELE0095')}: ${std}`
      }
      if (upper !== null) {
        result = result + `, ${this.$t('ELE0096')}: ${upper}`
      }
      if (lower !== null) {
        result = result + `, ${this.$t('ELE0097')}: ${lower}`
      }
      return result
    },
    getToolTips2(std, upper, lower) {
      let result = ``
      if (std !== null) {
        result = result + `, ${this.$t('ELE0273')}: ${std}`
      }
      if (upper !== null) {
        result = result + `, ${this.$t('ELE0274')}: ${upper}`
      }
      if (lower !== null) {
        result = result + `, ${this.$t('ELE0275')}: ${lower}`
      }
      return result
    },
  },
  async mounted() {
    this.displayChart()
    await this.$nextTick()
    this.initialMin = this.$data._chart.options.scales.yAxes[0].ticks.min
    this.initialMax = this.$data._chart.options.scales.yAxes[0].ticks.max
  },
  watch: {
    propsXRange: function () {
      this.displayChart()
    },
    propsValues: function () {
      this.displayChart()
    },
    propsYRange: function () {
      this.displayChart()
    },
  },
}
</script>
